var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vigilanti", attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.show_zoom,
              expression: "!show_zoom"
            }
          ],
          attrs: { md10: "" }
        },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Detalle Alerta" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.alerta.label,
                                  "data-vv-name": _vm.formFields.alerta.id,
                                  id: _vm.formFields.alerta.id,
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.alerta.id
                                  )
                                },
                                model: {
                                  value: _vm.formFields.alerta.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.alerta,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.alerta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.patente.label,
                                  "data-vv-name": _vm.formFields.patente.id,
                                  id: _vm.formFields.patente.id,
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.patente.id
                                  )
                                },
                                model: {
                                  value: _vm.formFields.patente.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.patente,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.patente.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.tipoAlerta.label,
                                  "data-vv-name": _vm.formFields.tipoAlerta.id,
                                  id: _vm.formFields.tipoAlerta.id,
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tipoAlerta.id
                                  )
                                },
                                model: {
                                  value: _vm.formFields.tipoAlerta.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tipoAlerta,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.tipoAlerta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.latitud.label,
                                  "data-vv-name": _vm.formFields.latitud.id,
                                  id: _vm.formFields.latitud.id,
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.latitud.id
                                  )
                                },
                                model: {
                                  value: _vm.formFields.latitud.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.latitud,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.latitud.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.longitud.label,
                                  "data-vv-name": _vm.formFields.longitud.id,
                                  id: _vm.formFields.longitud.id,
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.longitud.id
                                  )
                                },
                                model: {
                                  value: _vm.formFields.longitud.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.longitud,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.longitud.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md12: "" } },
                        [
                          _c(
                            "h2",
                            {
                              staticStyle: {
                                "font-weight": "normal",
                                margin: "12px 0px 0px",
                                "text-align": "left"
                              }
                            },
                            [_vm._v("\n              Ubicación\n            ")]
                          ),
                          _c("hr", {
                            staticClass: "v-divider theme--light",
                            staticStyle: { "margin-bottom": "20px" }
                          })
                        ]
                      ),
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("div", {
                          staticClass: "mapContainer",
                          attrs: { id: "mapContainer" }
                        })
                      ]),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md12: "" } },
                        [
                          _c(
                            "h2",
                            {
                              staticStyle: {
                                "font-weight": "normal",
                                margin: "12px 0px 0px",
                                "text-align": "left"
                              }
                            },
                            [_vm._v("\n              Archivos\n            ")]
                          ),
                          _c("hr", {
                            staticClass: "v-divider theme--light",
                            staticStyle: { "margin-bottom": "20px" }
                          })
                        ]
                      ),
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            wrap: "",
                            layout: ""
                          }
                        },
                        [
                          _vm.files.length == 0
                            ? _c(
                                "h3",
                                {
                                  staticStyle: {
                                    "font-weight": "normal",
                                    margin: "12px 0px 0px",
                                    "text-align": "center"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Sin Archivos multimedia\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._l(_vm.files, function(file) {
                            return _c(
                              "v-flex",
                              {
                                key: file.url,
                                attrs: {
                                  xs12: "",
                                  sm6: "",
                                  md6: "",
                                  wrapper: "",
                                  "wrapper-files": ""
                                }
                              },
                              [
                                file.url
                                  .split(".")
                                  .pop()
                                  .toLowerCase() == "mp4"
                                  ? _c(
                                      "video",
                                      {
                                        attrs: {
                                          width: "100%",
                                          controls: "",
                                          disablepictureinpicture: "",
                                          controlslist:
                                            "nodownload noplaybackrate",
                                          muted: ""
                                        },
                                        domProps: { muted: true },
                                        on: {
                                          contextmenu: function($event) {
                                            return _vm.handlerContexTmenu(
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("source", {
                                          attrs: {
                                            src: file.url,
                                            type: "video/mp4"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                Your browser does not support the video tag.\n              "
                                        )
                                      ]
                                    )
                                  : _c("img", {
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { src: file.url, width: "100%" },
                                      on: {
                                        click: function($event) {
                                          return _vm.zoom(file.url)
                                        }
                                      }
                                    }),
                                _c(
                                  "v-flex",
                                  {
                                    attrs: {
                                      xs12: "",
                                      sm6: "",
                                      md6: "",
                                      "buttons-img": ""
                                    }
                                  },
                                  [
                                    file.url
                                      .split(".")
                                      .pop()
                                      .toLowerCase() != "mp4"
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              flat: "",
                                              icon: "",
                                              small: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.zoom(file.url)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { icon: "" } },
                                              [_vm._v("zoom_in")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    file.url
                                      .split(".")
                                      .pop()
                                      .toLowerCase() != "mp4"
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              flat: "",
                                              icon: "",
                                              small: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.download_img(
                                                  file.url
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { icon: "" } },
                                              [_vm._v("download")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show_zoom,
              expression: "show_zoom"
            }
          ],
          attrs: { imagezoom: "", xs10: "", sm10: "", md10: "" }
        },
        [
          _c(
            "v-flex",
            {
              attrs: { "imagezoom-buttons": "", xs12: "", sm12: "", md12: "" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { flat: "", icon: "", small: "" },
                  on: { click: _vm.zoom_out }
                },
                [_c("v-icon", { attrs: { icon: "" } }, [_vm._v("zoom_out")])],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", icon: "", small: "" },
                  on: { click: _vm.zoom_in }
                },
                [_c("v-icon", { attrs: { icon: "" } }, [_vm._v("zoom_in")])],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", icon: "", small: "" },
                  on: {
                    click: function($event) {
                      return _vm.download_img(_vm.urlzoom)
                    }
                  }
                },
                [_c("v-icon", { attrs: { icon: "" } }, [_vm._v("download")])],
                1
              ),
              _c(
                "v-btn",
                {
                  staticStyle: { float: "right" },
                  attrs: { flat: "", icon: "", small: "" },
                  on: { click: _vm.zoom_close }
                },
                [_c("v-icon", { attrs: { icon: "" } }, [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: { "imagezoom-wrapper": "", xs12: "", sm12: "", md12: "" }
            },
            [
              _c("img", {
                staticClass: "img",
                attrs: { src: _vm.urlzoom, width: _vm.imagezoom_width }
              })
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }